import { useParams } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { COMPLIANCE_QUESTIONNAIRES } from "./complianceQuestionnaireRegistry";
import PolicyQuestionnairePage from "./PolicyQuestionnairePage";

export default function PolicyQuestionnaireRoute() {
  const { policyCode } = useParams();
  if (!COMPLIANCE_QUESTIONNAIRES[policyCode]) {
    return <Navigate to="/compliance/audit-tools" replace />;
  }
  return <PolicyQuestionnairePage policyCode={policyCode} />;
}